export const BFFUrl = window._env_.REACT_APP_BFF_BASE_URL;
